import { Home2TasksCard } from './Home2TasksCard';
import { Home2RoutinesCard } from './Home2RoutinesCard';
import { Home2AppsCard } from './Home2AppsCard';
import { Home2FilesCard } from './Home2FilesCard';
import { Home2ConnectorsSection } from './Home2ConnectorsSection';
import { Home2OutreachSection } from './Home2OutreachSection';
import styles from './Home2Body.module.css';

// The Home 2 (symphonyHome2Web) body — the bento rows under the header/brief (Figma 1859:2656),
// built for the SINGLE-workspace layout for now (multi-workspace adjustments come later).
//
// Row 1 = Tasks (left) + Routines (right). Only the Tasks card is built so far; the Routines card and
// the later rows (Apps/Files, Connectors, Outreach) drop into the same grid as they land.
export function Home2Body() {
  return (
    <div className={styles.body}>
      <div className={styles.row}>
        <Home2TasksCard />
        <Home2RoutinesCard />
      </div>
      <div className={styles.row}>
        <Home2AppsCard />
        <Home2FilesCard />
      </div>
      <Home2ConnectorsSection />
      <Home2OutreachSection />
    </div>
  );
}
